import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
function PrincipalMessage() { 
  useEffect(() => {
    document.title = 'Principal Message -  Mercy Memorial School, Kanpur';  
}, []); 
const [data, setData] = useState([]);
useEffect(() => {
 const fetchData = async () => {
   try {
     const msgdata = await getPrincipalMessage();
    const data = msgdata.filter((item) => item.category === "Principal");
    
     setData(data);
   } catch (error) {
     console.error("Error fetching online registration data:", error);
   }  
 };
 fetchData();
}, []);
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>Principal's Message</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Principal's Message</h2>
            </div>
          </div> 
          <div className="row">
          {data.length > 0 && (
            <div className="clearfix">
               <LazyLoad> <img 
                src={`https://webapi.entab.info/api/image/${data[0].attachments}`} 
                className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                alt={data[0].name || 'Image'}
              /></LazyLoad>
              <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
              <p className="name">
                {data[0].name}<span> {data[0].category} </span>
              </p>
            </div>
          )}

          {data.length === 0  && (
            <div className="clearfix">
               <LazyLoad> <img 
                src="https://webapi.entab.info/api/image/MMSKN/public/Images/dummy.jpg" 
                className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                alt=""
              /></LazyLoad>
              <p><b><i>An investment in knowledge pays the best interest." – Benjamin Franklin</i></b></p>
              <p>A warm welcome to Mercy Memorial School (MMS).</p> 
              <p>At MMS, we firmly believe that education is the foundation on which the future of the individuals and society is built. We are relentless in our pursuit of excellence because we understand the profound impact it can have on the lives of young people, their families and the wider community. We are committed to providing an environment where students not only thrive academically but also grow into responsible individuals who can contribute meaningfully to society. Our mission at MMS is to offer a well-rounded experience that blends academic excellence with cultural and practical learning. We aim to empower students with the knowledge and skills necessary to take control of their future and access a world of enhanced opportunities.</p>
              
              <p>The journey of learning is filled with hope and dreams, requiring dedication, perseverance, and an unwavering commitment to success. The rewards of this journey are transformative. At MMS, we are honoured to be part of this remarkable process. However, the journey would be incomplete without the tireless support of parents and the unyielding dedication of our teachers. As the head of the school, I deeply appreciate and commend the efforts of both the parents and teachers who work with us.</p>
              
              <p>The support of our entire school community—children, families and staff—is essential to our continued success. Together, we look forward to collaborating and building a bright future. As Swami Vivekananda wisely said,</p>
              <p><b><i>‘Education is the manifestation of the perfection already in man.’</i></b></p>
              <p className="name">
                  Mrs. Marina Cyril <span>  Principal </span>
              </p>
            </div>
          )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PrincipalMessage;
